import { createElementVNode as _createElementVNode, renderSlot as _renderSlot, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-54b17b92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog-wrapper" }
const _hoisted_2 = { class: "modal-dialog" }
const _hoisted_3 = { class: "close-icon-wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", {
          class: "close-icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('close')))
        })
      ]),
      _renderSlot(_ctx.$slots, "default", {}, undefined, true)
    ])), [
      [_directive_click_outside, _ctx.clickOutside]
    ])
  ]))
}